import React from "react";
import clsx from "clsx";
import { Modify } from "@saleshandy/designs/lib/types";

type CheckboxProps = Modify<
  React.HTMLProps<HTMLInputElement>,
  {
    label?: React.ReactNode;
    checked?: boolean;
    intermediate?: boolean;
    disabled?: boolean;
    onChange?: (
      checked: boolean,
      event: React.ChangeEvent<HTMLInputElement>
    ) => void;
  }
>;

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    { disabled, label, checked, intermediate, className, onChange, ...rest },
    ref
  ) => {
    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(event.target.checked, event);
    };

    const labelClass = clsx([
      "bs-checkbox-wrapper",
      {
        "bs-checkbox-wrapper-disabled": disabled,
      },
      className,
    ]);

    const spanClass = clsx([
      "bs-checkbox",
      {
        "bs-checkbox-disabled": disabled,
        "bs-checkbox-indeterminate": intermediate,
      },
    ]);

    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      <label className={labelClass}>
        <span className={spanClass}>
          <input
            {...rest}
            type="checkbox"
            className="bs-checkbox-input"
            checked={checked}
            disabled={disabled}
            onChange={onChangeHandler}
            ref={ref}
          />
          <span className="bs-checkbox-inner" />
        </span>
        {label && <span>{label}</span>}
      </label>
    );
  }
);

Checkbox.displayName = "Checkbox";

Checkbox.defaultProps = {
  intermediate: false,
  disabled: false,
};

export default Checkbox;
